import * as Sentry from '@sentry/react'

export function captureSentryException(
  error?: Error,
  options?: Parameters<typeof Sentry.captureException>[1],
) {
  if (window.__sentry__) {
    window.__sentry__.captureException(error, options)
  }
}
